import { createSelector } from "@ngrx/store";

export const selectStep = createSelector(
    (state) => state['assignments'],
    (assignmentsState) => assignmentsState.step
);

export const getSkills = createSelector(
    (state) => state['assignments'],
    (assignmentsState) => assignmentsState.skills
);

export const isCreatingAssignmentFromHistory = createSelector(
    (state) => state['assignments'],
    (assignmentsState) => assignmentsState.isAssignmentCreatingFromHistory
);

export const selectPreviousAssignment = createSelector(
    (state: any) => state['assignments'],
    (assignmentsState) => assignmentsState.previousAssignment
);

export const getSelectedShift = createSelector(
  (state: any) => state['assignments'],
  (assignmentsState) => assignmentsState.selectedShift
);

export const selectSelectedCategory = createSelector(
    (state: any) => state['assignments'],
    (assignmentsState) => assignmentsState.selectedShift
);


